export default "__VITE_ASSET__1f729c27__"